import React from 'react';
import { Box } from '@mui/material';
import SoundBars from './SoundBars';
import MarqueeText from './MarqueeText';

interface MarqueeWithBarsProps {
  text: string;
  animating?: boolean;
  fontSize?: number;
  sx?: object;
}

const MarqueeWithBars: React.FC<MarqueeWithBarsProps> = ({
  text,
  animating = false,
  fontSize = 11,
  sx,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, width: '100%', ...sx }}>
    <SoundBars active={animating} height={fontSize >= 12 ? 16 : 14} />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <MarqueeText text={text} sx={{ color: '#aaa', fontSize }} />
    </Box>
  </Box>
);

export default MarqueeWithBars;
